import PropTypes from 'prop-types';
import Link from '../link/link';

export default function OutlineSection({ dest, title, onClick }) {
  const href = `#go_to_${JSON.stringify(dest)}`;
  return (
    <li className="u-margin-xs-bottom">
      <Link
        onClick={(e) => {
          e.preventDefault();
          onClick(dest);
        }}
        className="text-s"
        dangerouslySetInnerHTML={{ __html: title }}
        href={href}
      />
    </li>
  );
}

OutlineSection.propTypes = {
  title: PropTypes.string,
  dest: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Array),
  ]),
  onClick: PropTypes.func.isRequired,
};

OutlineSection.defaultProps = {
  title: '',
  dest: [],
};
